import { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";

// Fired after anything that changes the games list (accept, decline, a
// fresh Your games load), so the header badge refreshes straight away.
export const GAMES_CHANGED_EVENT = "jangle:games-changed";

export function gamesChanged() {
  window.dispatchEvent(new Event(GAMES_CHANGED_EVENT));
}

/** Challenges waiting + games against people where it's your move, polled
 *  for the header. Browser players get no push, so this is their signal. */
export function useGamesBadge(enabled) {
  const [badge, setBadge] = useState({ invites: 0, yourTurn: 0, gameOver: 0 });

  const load = useCallback(async () => {
    if (!enabled || document.visibilityState === "hidden") return;
    try {
      const { data } = await api.get("/me/games/badge");
      setBadge({ invites: data.invites || 0, yourTurn: data.your_turn || 0, gameOver: data.game_over || 0 });
    } catch { /* keep the last count */ }
  }, [enabled]);

  useEffect(() => {
    if (!enabled) {
      setBadge({ invites: 0, yourTurn: 0, gameOver: 0 });
      return undefined;
    }
    load();
    const t = setInterval(load, 30000);
    window.addEventListener(GAMES_CHANGED_EVENT, load);
    window.addEventListener("focus", load);
    document.addEventListener("visibilitychange", load);
    return () => {
      clearInterval(t);
      window.removeEventListener(GAMES_CHANGED_EVENT, load);
      window.removeEventListener("focus", load);
      document.removeEventListener("visibilitychange", load);
    };
  }, [enabled, load]);

  return badge;
}

// Fired after a challenge is sent from Find opponent, so Your games shows
// it straight away. (Separate from GAMES_CHANGED_EVENT, which Your games
// itself fires after every load.)
export const CHALLENGE_SENT_EVENT = "jangle:challenge-sent";
